import { Row, Col, Container } from "react-bootstrap";
import JSONPretty from "../../jsonPrettyOverride/JSONPretty";
import { OrgIdContext } from "../../../store/orgId_context";
import { tx } from "../../../lib/ddd/ddd";
import classes from "./IntegrationComponentsFull.module.scss"
import { Skeleton } from "@mui/material";
import { useContext } from "react";
import ReceiptIcon from '@mui/icons-material/Receipt';

const CSharpWhatTo = ({objectResponse, complexity="Normal"}) => {
    const {  integrationDevice } = useContext(OrgIdContext);
    return (<>
    <Row>
        <Col style={{position:"relative"}}>
        <p>
            On the right side, there is any example of an object {tx("DDDI_Save")} API expexct to recieve. Most of the information is empty and expected to be filled by
            informations from your solutions. This example will return an error because of missing content. The purpose of this example is only to show, what parameters
            the API expects to recieve.
        </p>
        <div><ReceiptIcon/>Get initialized invoice</div>
        <p style={{fontSize:"0.8rem"}}>
            As you can see on the right side, some of the information is already prefilled (BuyerTypeCode, BuyerCountryCode, DeviceId, etc). The values of these properties
            are derived from your account settings or country. If you wish to get such an Invoice object with prefilled initialized information, you can send a request to <span className={classes["complexityApiText"]}>{tx("EUeInvoices.DDDI_GetNew")}</span> API.
            Because these values are subject
            to change (country's laws, company setting) it is best to request this object often and not store it locally for longer periods of time.
        </p>
        <div className={classes["code-snippet"]} style={{fontSize:"0.8rem", /*position:"absolute", bottom:"0", left:"0.2rem"*/}}>
            var client = new HttpClient();<br/>
            client.DefaultRequestHeaders.Add("Authorization", "IoT <span className={classes.green}>{integrationDevice}</span>:EUeInvoices");<br/>
            var response = await client.PostAsync("https://{window.location.hostname}/api/service/EUeInvoices.<span className={classes.green}>{tx("DDDI_GetNew")}"</span>, new StringContent(<span className={classes.green}>"&#123;Complexity:\"Normal\"&#125;"</span>, Encoding.UTF8, "application/json"));
        </div>
        {/* <p>
            Below, in the object preview display, there is an example of such an initialized invoice.
        </p> */}
        </Col>
        <Col>
            Example object:
            {!objectResponse && <Skeleton style={{WebkitTransform:"none"}} width="100%" height="50vh"/>}
            {objectResponse && <div className={classes["json-wrapper"]} style={{textAlign : "left", height:"100%", maxHeight:"50vh"}}>
                <JSONPretty data={{Complexity : complexity, Object: objectResponse.Invoice}}></JSONPretty>
            </div>}
        </Col>
    </Row>
    </>)
}

export default CSharpWhatTo;